import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { StyledPrimaryButton } from "../Components/StyledComponents/Buttons";
import { DialogModalWithForm } from "../Components/DialogModal";
import { useStores } from "..";
import { PasswordInput } from "../Components/PasswordInput";
import dictionary from "../langs.json";
import { ServerRequestError } from "../ServerClients/Configs";

export const RegistrationForm: React.FC<{}> = observer(() => {
  let appStores = useStores();
  let mainWindowStore = appStores.mainWindowStore;
  let registrationStore = appStores.registrationStore;
  const [errorStatus, setErrorStatus] = useState<number | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [registered, setRegistered] = useState(false);
  const language = navigator.language.toLowerCase().split("-")[0] === "en" ? "en" : "ru";
  const messages = dictionary[language].translation;

  useEffect(() => {
    setErrorStatus(null);
    setRegistered(false);
  }, [mainWindowStore.showRegistration]);

  if (!mainWindowStore.showRegistration) {
    return null;
  }

  let closeRegistrationAndShowUserLogin = function () {
    mainWindowStore.onRegistrationClose();
    mainWindowStore.onUserLoginOpen();
  };

  return (
    <DialogModalWithForm
      className="auth-form"
      onCloseClick={mainWindowStore.onRegistrationClose}
      onSubmit={() => {
        if (submitting || registered) return;
        setErrorStatus(null);
        const request = registrationStore.registrateUser();
        if (!request) return;
        setSubmitting(true);
        request.then(() => setRegistered(true))
          .catch((error: unknown) => setErrorStatus(error instanceof ServerRequestError ? error.status : 0))
          .finally(() => setSubmitting(false));
      }}
    >
      <DialogModalWithForm.Header>Регистрация</DialogModalWithForm.Header>

      <DialogModalWithForm.Body>
        {registered ? (
          <div className="registration-success" role="status">
            <p>{messages.registration_success}</p>
            <p>{messages.registration_confirm_email}</p>
          </div>
        ) : <>
        {errorStatus !== null && (
          <div className="registration-error" role="alert">
            <p>{errorStatus === 412 ? messages.registration_exists : messages.registration_failed}</p>
            {errorStatus === 412 && <>
              <p>{messages.registration_reset_advice}</p>
              <a href="#password-reset" onClick={(event) => {
                event.preventDefault();
                mainWindowStore.onPasswordResetOpen();
              }}>{messages.registration_reset_link}</a>
            </>}
          </div>
        )}
        <div>
          <label htmlFor="registration-name">Имя</label>
          <input
            id="registration-name"
            type="text"
            placeholder="Имя"
            className="login"
            required
            onChange={registrationStore.onChangeUserName}
          />
        </div>
        <div>
          <label htmlFor="registration-email">Электронная почта</label>
          <input
            id="registration-email"
            type="email"
            placeholder="Почта"
            required
            onChange={(event) => {
              setErrorStatus(null);
              registrationStore.onChangeUserMail(event);
            }}
          />
        </div>
        <div>
          <label htmlFor="registration-password">Пароль</label>
          <PasswordInput
            id="registration-password"
            type="password"
            placeholder="Пароль"
            minLength={8}
            required
            onChange={registrationStore.onChangeUserPassword}
          />
        </div>
        <div>
          <label htmlFor="confirm-password-input">Повторите пароль</label>
          <PasswordInput
            type="password"
            placeholder="Повторите пароль"
            id="confirm-password-input"
            required
            onChange={registrationStore.onChangeConfirmPassword}
          />
        </div>
        <div className="block">
          <StyledPrimaryButton type="submit" disabled={submitting} aria-busy={submitting}>Регистрация</StyledPrimaryButton>
        </div>
        </>}
      </DialogModalWithForm.Body>
      <DialogModalWithForm.Footer>
        <a onClick={closeRegistrationAndShowUserLogin}>Войти</a>
      </DialogModalWithForm.Footer>
    </DialogModalWithForm>
  );
});
